import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { logout } from "../store/actions/authAction";

function Auth(props) {
  let auth = useSelector((state) => state.authUser);
  const dispatch = useDispatch();
  const history = useHistory();
  const urlParams = new URLSearchParams(window.location.search);
  const redirectPath = urlParams.get("redirect");
  const athleteIdParam = urlParams.get("athleteId");
  console.log(redirectPath);

  React.useEffect(() => {
    if (athleteIdParam) {
      if (auth.uid && auth.uid !== athleteIdParam) {
        dispatch(logout(auth.uid));
      }
      const params = new URLSearchParams(window.location.search);
      params.delete("athleteId");
      const newSearch = params.toString();
      const newPath = window.location.pathname + (newSearch ? `?${newSearch}` : "");
      history.replace(newPath);
    }
  }, [athleteIdParam, auth.uid, dispatch, history]);

  if (auth.uid && !athleteIdParam) {
    if (redirectPath) {
      window.location.href = redirectPath;
    } else {
      history.push("/dashboard");
    }
  }
  return <div>{props.children}</div>;
}

export default Auth;
